import { FC } from 'react';

import LogoLink from 'app/components/layout/AppLayout/LogoLink';
import Box from 'app/components/v2/components/Box';
import { useIsTriumphInternal } from 'app/state/AuthContext/hooks';

import AccountMenu from './AccountMenu';
import { NavProps } from '..';

// Component Definition
const DesktopNav: FC<NavProps> = props => {
  const isTriumphInternal = useIsTriumphInternal();

  return (
    <Box
      alignItems="center"
      display="flex"
      justifyContent="space-between"
      paddingX={6}
      paddingY={3}
    >
      <LogoLink
        size="large"
        to={props.logoPath}
        variant="light"
      />
      <Box
        alignItems={isTriumphInternal ? 'flex-end' : 'center'}
        display="flex"
        flexDirection={isTriumphInternal ? 'column-reverse' : 'row'}
        role="navigation"
      >
        <AccountMenu
          shouldRenderCompanyName
          shouldRenderCompanyType={isTriumphInternal}
        />
      </Box>
    </Box>
  );
};

export default DesktopNav;
